module.exports = __webpack_public_path__ + "img/gift4-01-c06-y2.bda2fa45.png";